import { useCallback, useEffect, useState } from 'react'
import { getApi } from '@BUP/services/Axios'

export const useSurveyQuestionsByPage = (surveyId, pageId) => {
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState(null)
  const [error, setError] = useState(null)
  const getData = useCallback(async () => {
    setIsLoading(true)
    const client = await getApi('sociogram', { authenticated: true })
    return client
      .get(
        `/questions?survey_ids=${surveyId}&page_id.number=${pageId}&isChildren=false`
      )
      .then(response => response.data)
      .then(data => {
        setError(null)
        setData(data)
      })
      .catch(error => {
        setError(error)
        setData(null)
      })
      .finally(() => setIsLoading(false))
  }, [setIsLoading, setError, setData, surveyId, pageId])

  useEffect(() => {
    if (surveyId && pageId) {
      getData()
    }
  }, [getData, surveyId, pageId])

  return {
    isLoading,
    data,
    error
  }
}
